var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "chevron-left",
  "use": "chevron-left-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"chevron-left\">\n<!--Generated by IJSVG (https://github.com/iconjar/IJSVG)-->\n    <path d=\"M12.452,4.516c0.446,0.436 0.481,1.043 0,1.576l-3.747,3.908l3.747,3.908c0.481,0.533 0.446,1.141 0,1.574c-0.445,0.436 -1.197,0.408 -1.615,0c-0.418,-0.406 -4.502,-4.695 -4.502,-4.695c-0.223,-0.217 -0.335,-0.502 -0.335,-0.787c0,-0.285 0.112,-0.57 0.335,-0.789c0,0 4.084,-4.287 4.502,-4.695c0.418,-0.409 1.17,-0.436 1.615,0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-left.svg
// module id = 551
// module chunks = 35783957827783